import { useSyncExternalStore } from 'react';

/*
 * A few routes don't need a router library: the path is the state, and the
 * service worker already serves index.html for every navigation.
 */

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());
window.addEventListener('popstate', notify);

export function navigate(to: string, { replace = false } = {}) {
  if (to === location.pathname) return;
  history[replace ? 'replaceState' : 'pushState'](null, '', to);
  window.scrollTo(0, 0);
  notify();
}

export function usePath(): string {
  return useSyncExternalStore(
    (cb) => {
      listeners.add(cb);
      return () => listeners.delete(cb);
    },
    () => location.pathname,
  );
}

export type Route =
  | { page: 'wishlist' }
  | { page: 'outfits' }
  | { page: 'outfit'; id: string }
  | { page: 'outfit-edit'; id: string | null }
  | { page: 'boards' }
  | { page: 'board'; id: string };

export function parseRoute(path: string): Route {
  const parts = path.split('/').filter(Boolean);
  if (parts[0] === 'boards') return parts[1] ? { page: 'board', id: parts[1] } : { page: 'boards' };
  if (parts[0] !== 'outfits') return { page: 'wishlist' };
  if (parts.length === 1) return { page: 'outfits' };
  if (parts[1] === 'neu') return { page: 'outfit-edit', id: null };
  if (parts[2] === 'bearbeiten') return { page: 'outfit-edit', id: parts[1]! };
  return { page: 'outfit', id: parts[1]! };
}
